import type { PlayerDetailData } from '@/hooks/use-coach-data';
import { EvaluationCard } from '@/components/shared/evaluation-scores-grid';
import { EmptyState } from '@/components/shared/empty-state';

interface EvaluationsTabProps {
  evaluations: PlayerDetailData['evaluations'];
  stats: PlayerDetailData['stats'];
}

export function EvaluationsTab({ evaluations, stats }: EvaluationsTabProps) {
  if (evaluations.length === 0) {
    return <EmptyState title="No evaluations recorded yet." />;
  }

  return (
    <div className="space-y-4">
      {/* Averages Card */}
      {stats.evalAverages && (
        <div className="grid grid-cols-3 gap-2">
          {Object.entries(stats.evalAverages).filter(([, v]) => v != null).map(([key, value]) => (
            <div key={key} className="text-center p-2 bg-muted/40 rounded-lg">
              <p className="text-lg font-bold text-foreground">{value}</p>
              <p className="text-[10px] text-muted-foreground capitalize">
                {key.replace(/([A-Z])/g, ' $1').trim()}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Evaluation List */}
      <div className="space-y-3">
        {evaluations.map(eval_ => (
          <EvaluationCard key={eval_.id} evaluation={eval_} size="sm" />
        ))}
      </div>
    </div>
  );
}
